<template>
  <div class="p-date-dropdown-container">
    <p-vue-dropdown
      class="p-date-dropdown"
      :options="years"
      v-model="year"
      @change="$emit('changeDate', year)"
    >
      <template #value="{ value, placeholder }">
        <div class="label">
          <span class="value">{{
            value ? (value.label ? value.label : value) : placeholder
          }}</span>
          <i-icon name="arrow" />
        </div>
      </template>
    </p-vue-dropdown>
  </div>
</template>

<script>
export default {
  emits: ["changeDate"],
  data() {
    return {
      year: null,
      years: null,
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
    this.years = [this.year - 3, this.year - 2, this.year - 1, this.year];
  },
};
</script>

<style scoped>
.p-date-dropdown-container {
  display: flex;
  justify-content: center;

  padding-bottom: 10px;
}

.p-date-dropdown {
  max-width: 100%;

  padding: 0;

  border: none;
  border-radius: 0;
  background-color: var(--color-success);

  clip-path: polygon(0 0, 100% 0%, 90% 100%, 10% 100%);
}

.p-date-dropdown:deep(.p-dropdown-label) {
  padding: 7px 25px;
}

.label {
  display: flex;
  align-items: center;

  color: white;
}

.label:deep(.svg) {
  width: 13px;
  height: 13px;

  margin-right: 8px;
}

.value {
  flex: 1;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
